import { render, staticRenderFns } from "./orderArray.vue?vue&type=template&id=a4f59894&scoped=true&"
import script from "./orderArray.vue?vue&type=script&lang=js&"
export * from "./orderArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f59894",
  null
  
)

export default component.exports